import React, { ReactNode } from 'react';

import { Space, Typography } from '@sravni/react-design-system';

interface Props {
  title?: string;
  className?: string;
  children: ReactNode;
}

export const ListGroup: React.FC<Props> = ({ title, children, className }) => {
  return (
    <Space direction="vertical" size={16} className={className}>
      <Typography.Heading level={3} className="h-ml-20">
        {title}
      </Typography.Heading>
      {children}
    </Space>
  );
};
